import { render, staticRenderFns } from "./CajaChica.vue?vue&type=template&id=4253036e&"
import script from "./CajaChica.vue?vue&type=script&lang=js&"
export * from "./CajaChica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CajaChica.vue"
export default component.exports